(function (Drupal, drupalSettings) {
  Drupal.behaviors.lang = {
    attach: function (context, settings) {
      const langSwitchers = context.querySelectorAll(
        "ul.language-switcher-language-url"
      );
      langSwitchers.forEach((container) => {
        if (!container.dataset.langProcessed) {
          container.dataset.langProcessed = "true";

          const activeLangItem = container.querySelector("li.is-active a");
          const activeLang = activeLangItem ? activeLangItem.textContent : "";
          const parent = container.parentElement;

          const label = document.createElement("span");
          label.className = "label";
          label.innerHTML = `${activeLang}<i class="fas fa-angle-down"></i>`;
          parent.prepend(label);

          const activeLangLi = container.querySelector("li.is-active");
          if (activeLangLi) {
            activeLangLi.remove();
          }

          label.addEventListener("click", () => {
            container.style.display =
              container.style.display === "block" ? "none" : "block";
            const icon = label.querySelector(".fas");
            icon.classList.toggle("fa-angle-down");
            icon.classList.toggle("fa-angle-up");
          });

          document.addEventListener("click", (e) => {
            if (!e.target.closest(".lang")) {
              container.style.display = "none";
              const icon = label.querySelector(".fas");
              icon.classList.remove("fa-angle-up");
              icon.classList.add("fa-angle-down");
            }
          });

          document.addEventListener("scroll", () => {
            if (document.documentElement.scrollTop > 60) {
              container.style.display = "none";
              const icon = label.querySelector(".fas");
              icon.classList.remove("fa-angle-up");
              icon.classList.add("fa-angle-down");
            }
          });
        }
      });
    },
  };
})(Drupal, drupalSettings);
